import React from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  useCouponByIdRelayQuery,
  mapCouponToICoupon,
} from '../../hooks/coupons/query/V2';
import { ICoupon } from '../../ts/interface/coupon.interface';
import { IMode } from '../../ts/interface/mode.interface';
import { findAccess } from '../../utils';
import { IAuth } from '../../ts/interface/admins.interface';
import CouponForm from '../../components/coupons/CouponForm';

const CouponEdit = ({
  systemLoaded,
  systemAccess,
  movaticAccess,
}: {
  systemLoaded: boolean;
  modeInfo: IMode;
  movaticAccess: number;
  systemAccess: number;
}) => {
  const { couponId } = useParams<{ couponId: string }>();

  const { data: couponData, isLoading } = useCouponByIdRelayQuery(couponId, {
    enabled: systemLoaded && !!couponId,
  });
  const coupon: ICoupon | undefined = couponData
    ? mapCouponToICoupon(couponData)
    : undefined;

  const saveDisabled = !findAccess(systemAccess).includes('rates') && !movaticAccess;

  return (
    <CouponForm
      key={coupon?.id ?? 'loading'}
      scope="system"
      mode="edit"
      systemLoaded={systemLoaded && !isLoading}
      initialValues={coupon}
      couponId={couponId}
      cancelHref={`/billing/coupon/${couponId}`}
      successHref={`/billing/coupon/${couponId}`}
      saveDisabled={saveDisabled}
      title="Edit Coupon"
    />
  );
};

export default connect(
  (state: {
    system: { isLoaded: boolean };
    mode: IMode;
    admin: {
      admin: IAuth;
      systemAccess: number;
    };
  }) => ({
    systemLoaded: state.system.isLoaded,
    modeInfo: state.mode,
    movaticAccess: state.admin.admin.admin.movaticAccess,
    systemAccess: state.admin.systemAccess,
  }),
  () => ({})
)(CouponEdit);
